let excuses = `I'm watching tv
I'm having a glass of wine
I'm hanging out with my friends
I'm going to my parents house
I'm having a business lunch
I'm going to the lake
I'm going to church
I'm going to a wedding
I'm going to the grocery store
I'm going to a bar
I'm going to a party
I'm going to a funeral
I'm going to the park
I'm going to the library
I have to clean out the garage
I have to see my doctor
I have to go to my brother's wedding
I have to go to the hair salon
I have to go to disneyland
I have to go to the beach
I'm going to a movie with my friends
I'm going to a fashion show
I have to take my mom to the doctor
I'm busy
I'm tired
my car is in the shop
I have to go to the dentist
I have to have a meeting with my lawyer
I have to go to my parents' house to fix dinner for them because they are both extremely busy
I have to go to the post office because my husband never picks up his mail
I have a meeting with my obgyn
I have to pay my electric bill
I have to go to court because my son is a moron
I have to go to the hospital because my husband is having chest pains.
I have to visit my parents because they're dying of cancer
I have to go to a meeting at my job because I'm a segmental paver
I have to finish my book report for my book club
I have to go to the funeral of my pet cat, blackie
I have to finish my book about ghost hunting
I have to go to the post office because my husband forgot to mail the bills
I have to have a root canal
I am making dinner for my family
I have to go to the gym
I have to go to the hair salon
I have to go shopping
I have to go to the library
I have to go home and feed my cat
I have to go home and feed my dog
I have to go home and feed my husband
I have to go home and feed my goldfish
I have to go home and feed my fish tank
I have to go home and feed my fish tank but first I have to clean it
I am washing my hair
I have to make a scrapbook because my son is interested in scrapbooking
I have to read a book for my book club on thursday night
I have to go to the dentist
I have to make sure my husband doesn't burn down the house
I have to go to the doctor because I think I may have cancer
I have to go to the gym because I am overweight
I have to go grocery shopping for my husband because he is an idiot
I have to do laundry because I just wore my favorite shirt and it has a stain on it
I have to go to the spa for a massage because my back hurts
I have to go to the bank because my husband lost our checkbook
I have to go to a concert tonight because it's my favorite band's last concert ever
I have to go shopping for my daughter's birthday party tomorrow
I have to go to the dentist because I have a cavity
I have to go to the library and update the computer catalogue because I can't find a book
I have to cut my children's hair
I have to pick up my mom from the airport
I have to work on my book with my friends because we're almost done
I have to work on my play with my friend sarah because we're almost done
I have to do laundry because I'm out of socks
I have to go to an award ceremony for my friend who was just awarded a grant to study the effects of earth on mars
I have to go to a very important meeting
I have to go on a date with an old crush
I have to meet my friend for a movie
I have to go to a conference
I'm going to see my boyfriend
I'm going to get coffee with my friend
I'm going to get lunch with my friend
I'm going to watch the movie frozen with my nieces
I'm going to the theater with my brother
I'm going to see the new iphone that I'm getting for free from my work.
I have to get my car inspected
I have to meet my friend for coffee to discuss her upcoming vacation
I have to update my list of to dos
I have to go to some art class at the local university
I have to update my list of potential dates for my husband so he can find somebody else to do taxes with.
I have to pick up my kids from soccer practice because my husband is out of town
I have to get a prescription for a new medicine because I forgot to re-order my old one
I have to water the plants in my garden because I have a lot of houseplants right now
I have to go shopping for a new car because my old one is too small and I need a big car
I have to go to therapy because my therapist said I was doing well.
I have to go to work because my boss asked me to work on that day.
I have to go to the hospital to visit my dying mother.
I have to work on my soap business
I have to make soap and need to do research first
I have to fix my car because it broke down on the way to the airport
I have to fix my car because it broke down on the way to the airport and I'm flying out to visit my cousin who is dying from cancer
I have to visit my father in the hospital because he's dying from cancer
I have to visit my mother in the hospital because she was accidentally shot and is paralyzed from the waist down.
I have to go shopping with my wife who is too emotional to go alone
I have to go to a funeral for my friend jane who was killed by her husband
I have to go to a concert because I really like the band
I have to go to a party because I met a really cute guy
I have to take care of my pet iguana because it has cancer
I have to take care of my child because he is special needs
I have to go to a seminar because I want to make more money
I have to call my mom because she is going through a divorce and I want to see her fail at life
I have to go to a bridal shower for my sister's friends
I have to watch my brother's pets while he goes on vacation
I have to do my hair
I have to be a bridesmaid at my cousin's wedding
I have to go to the gym for at least 2 hours every day
I have to go swimming every night in the cold month of february with my friend bill who has cancer
my family is extremely poor and they rely on me for income.
I have to go to a family reunion and be nice to my cousin's ex-wife's new husband
I have to go shopping with my friend who is jealous of my financial success and is trying to get me in trouble with the irs
I have to go see a play with my ex-boyfriend who promised me the world but didn't deliver when we were dating
I have to go to a funeral
I have to go to a wedding shower
I have to take my dog to the vet
I have to go to the county fair
I have to go to church
I have to get a haircut
I have to go to the eye doctor
I have to go to the dentist
I have to go shopping for shoes
I have to get my hair done
I have to go on vacation
I have to paint my house
I have to go take care of my mother
I have to go visit my brother in prison
I have to go visit my sister in rehab
I have to go visit my sister in the hospital because she had a baby
my sister is back from her mission and I want to see her
I'm going to the gym
I have an important work meeting
I'm going to a poetry reading
I'm going to a poetry reading where I will be performing too
I'm getting a haircut because the one I have now is terrible
I have to go to the dentist because there's a big cavity in my teeth and I don't want it to get worse.
I have to go to my son's school and tell the teacher he is a special needs child
I have a doctor's appointment and need to get my prostate checked because it's been feeling odd lately
I have to get my car serviced because the check engine light is on
I have to go on a date with my husband because we haven't had sex in three months
I have to go to a funeral of a family member
I have to go to the doctor for a check-up because my mother is concerned that I haven't been feeling well
my cat is going to die and I need to make sure he passes without suffering
I have a friend's birthday party to attend
I have to go to a restaurant with my husband so he has an excuse to
I have to pick up my son from the airport because his father was going to die but he didn't.
I have to go pray to the good lord jesus christ for he will bring the righteous to heaven after they die
I have to go bodybuild because it is good for my health
I have to go to the gym to tan my skin
I have to go to the gym because I want to increase my muscle mass
I have to go to my daughter's soccer game
my oldest child is getting married and I need to pamper myself.
I have to get coffee with my friend because she's an imbicile 
I have to go camping with my family because my father in law loves camping
I have to go to a cancer conference in the netherlands
I have to a meeting about getting funding for my research
I'm going to belgium to get my dna sequenced
I have to go to a talk about whether there is life on mars
I have to go to a talk about whether there is life on europa
I have to go to a talk about how cancer is a fungus
I have to go to a talk about how cancer is a bacterium
I have to do my taxes for my spouse because he is an imbicile
I have to go to a talk about how there are no germs
I have to go to a talk about how germs are just chemicals
I have to go to a seminar about how the
I have to go to the hospital because my spouse was shot by a robber
I have to go to the hospital because my spouse is having a baby
I have to go shopping because my spouse didn't buy my new shoes
I have to go shopping because I need a new dress for your dinner party
I have to go shopping because I need a new dress for my boss's dinner party
I have to go shopping because I need new clothes for my taekwondo lesson
I have to go shopping because my spouse doesn't know how to get clothes for me
I have to go to the salon because my spouse doesn't know how to do my hair
I have to go to the free clinic because my spouse has a bad back and cannot work
I have to have a mole removed from my anus
I have to go to the drugstore because my vagina is dry and it's making me uncomfortable
I have to go to the auction house to put my dead husband's belongings in storage because I'm moving in with my boyfriend and he's made me uncomfortable with his willy
I have to go to the bank because my spouse deposited all of our money in a savings account instead of a checking account
I have to go to the grocery store because I ran out of potpourri
I have to go to the library because I'm having a disagreement with my spouse about the meaning of the word "flaccid".
I have to go to a car dealership because I'm having a disagreement with my spouse about the meaning of the word "impotent".
I have to...
I have a lot of work to do at home, and I have two full-time jobs and my spouse does nothing.
I like to keep myself busy. 
I have to do some research on theoretical physics because I'm interested in fringe science
I have to go to the hospital because my cat is dying
I have to go to the doctor because I think I'm pregnant
I have to go to a funeral for a friend who died of cancer
I have to pick up my son from his violin lesson
I have to go to the doctor because I have a tumor
I have to go to a pottery class
I have to go to the emergency room because I have a heart attack
I have to meet my friend nancy for dinner
I have to go to the dentist
I have to go on a date with a beautiful woman named megan
I have an important business meeting with my boss
I have to get my nails done
I have a filling I have to get at the dentist
I have to fill out my tax returns
I have to get my hair cut
I have to file my taxes
I have to go to the mall and get a manicure with my mistress
I have to meet with my step-daughter to discuss the inheritance she will receive when I die of cancer soon
I have to go to the gym before I can go have coffee with you
I have to pick my children up from school and they always are late
I have to call my agent, he's waiting for me to sign a contract for a movie role where I am going to die of cancer, he can't leave a message on my phone because my spouse has a habit of checking my phone for messages
I have to go shopping for an anniversary present for my spouse who is going to die of cancer soon but he already has everything he wants.
I have to go to a meeting at work
I have to pick up my son from school
I have to watch my daughter's dog because it's not housetrained
I have to go to the store to get some more bread for her dog's food
I need to get my blood pressure checked because I think I might be having a heart attack
I have to get a new car because my current car is not safe enough
I have to go to the store for more dog food
I have to get some more dog food because my neighbors don't feed him anymore
I have to buy a new dog food because my current dog food is not making him grow anymore
I have to buy dog food because
I have to get a new plant for my wife's birthday
I have to go to the gym
I have to go on a hike
I have to go to the dentist
I have to go to the grocery store
I have to go to work
I have to drive my brother to the airport because he's going on vacation for the next 7 weeks 
I have to change my oil
I have to give a presentation at work about the new coffee machine I just bought for the break room
I have to go on a date with my friend harry who is going to die of cancer soon
I have to go on a date with my friend harry
I have to go to my doctor to get my annual physical.
I have to go shopping for the party because my spouse and I are broke
I have to go to the dentist because I have a cavity
I have to go to church because it's sunday. 
I have to go to the gym because I want to live forever and have a great body
I have to go to the bank because I have money that I don't know what to do with
I have to get my nails done because my nails are disgusting and I have a nail appointment
I have to buy groceries because we are out of milk and eggs
I have to get gas because the car is on empty
the cat has puked on the couch so I have to clean up puke from the couch
my friend is getting married so I have to be there because it's
I have to complete my class project for the history of art class
I have to finish my class project for the history of art class
I have to prepare a talk for my class
I have to finish my class project for the history of art class 
I have to have therapy for my workaholic husband who has an addiction to coffee
I have to go on a date with my husband who is extremely busy because he's in a relationship with a woman who is an ass
I have to clean the kitchen because I forgot to do it
I have to buy cat food because my cat is sick
I have to make a donation to the church because I forgot to make one
I have to order a new computer mouse because mine is broken
I have to go to the dentist, because I was in a car accident and I'm not sure if I need a root canal or a crown
I have to put a new battery in my car because I forgot to put one in my car when I left it overnight
I have to make a payment on my credit card because it's due
I have to make a payment on my student loan because it's due
I have to pay my mortgage because it's due
I have to buy a new computer for the school because we have a
I think I'm going to be arrested for a dui
I have to go to work because I'm short on money and I have a couple of "emergency" trips to make
my dog is sick
I want to go to the gym and get my butt kicked
I have to get a haircut
I have many other projects that need to be done
I want to meet up with my wife and have sex with her
I want to go to the movies but my wife and I are having a fight about something.
I have to drink beer with my friend at his house because he wants to go to the movies.
I have to go buy some food at trader joe's because my fridge is empty
I have to pick up my daughter from school because she's sick.
I have to do my taxes because my spouse forgot to do them and he's an imbicile
I have work on tuesday, thursday, friday, and saturday
I have to help my friend who has had an emergency appendectomy
I have to help my friend who has had an emergency hysterectomy
I have to help my friend because he has broken his leg and can't drive
I have to help my friend who is having a baby
I have to go help my friend who is getting an implantation of pacemakers
I have to go help my friend who is getting a new hip
I have to help my friend who is having a new knee
I have to help my friend who is having a brain surgery
I have to help my friend who is having a new hip replacement
I have to go help my friend who is having a hernia repair
I have to go help my friend who is having an emergency eye
I have to go grocery shopping
I have to do this musty, musty, musty task that needs to be done
I have to get a manicure
I have to do my taxes because the irs is going to invade our house in the middle of the night and kill our dog
I have to do my taxes because I'm a venezuelan drug lord
I have to do my taxes because I'm a mexican drug lord
I have to do my taxes because my wife is a crazy squirrel
I have to do my taxes because I'm a crazy squirrel
I have to go home and help my family cook dinner because I am the only one with a drivers license
I have to go home and help make dinner for my family because it is a holiday.
my son gets called up to the military tomorrow.
my son has been called up to the military, and I have to teach him how to drive.
I have to play poker with my buddy steve because he's a loser
I have to go to the store because I forgot to pick up milk and eggs for dinner
I have to go to the gym because I'm a woman
I have to go to the dmv in the morning because I haven't registered my car and it's past registration. I don't know how to register said car.
I have to go see my doctor because my cholesterol is too high.
I have to do my taxes because my spouse forgot to do them and he's an imbicile
I have to go get a new license plate because my old one expired.
I have to make plans to go to dinner with my friend lisa who just found out she's pregnant
I have to take a client on a date and pay him for his time 
I have to go to a wedding and dance with the bride.
I have to watch my kids.
I have to go to a baby shower for my sister-in-law
I have to take my husband out for dinner for our anniversary
I have to go grocery shopping.
I have to take my husband out for a nice dinner. 
I have to take my husband out for ice cream
I have to bake a cake for my son's birthday
I have to get my hair cut at the salon
I have to go to the dentist because I need a root canal
I have to go to the dentist because I have a leak and need a crown
I have to go to the dentist because I am experiencing new pain
I have to go to the dentist because my previous dentist was not doing enough root canals and crowns and now I am experiencing pain that is new
I have to go to the dentist because my last dentist did not do enough root canals and crowns.
I have to go to the dentist because I am experiencing pain that is new and this time it is not caused by old pain.
I have to go to the ballet to see my daughter dance
I have to have a meeting about putting up a new sign for the restaurant that I work at
I have to go to the bar I work at so I can get some more tips
I have to take my car in for service
I have to stop in at the office for a meeting about the new rules that the boss wants
I have to finish a project I'm working on before the end of the month
I have to go to the library to check out books for a conference that I'm going to in two weeks
I have to go grocery shopping because the food at my house sucks
I have to get my computer fixed because it's giving me problems
I have to go to the dentist so I can get my teeth cleaned
I have to go to a meeting at
I have to go running because I said I would today
I have to go running because I said that I would today
I have to go running because it's winter
I have to go running because it's cold
I have to go running because this is the only time of year that I can go running
I have to go running because I can't stop
I have to go running because I want to go running
I have to go running because I hate going running
I have to go running because my periods are late because of my overactive thyroid
I have to go running because my periods are late and a little bit of my thyroid was removed last week and it's acting up again so I'm going to get medication
I'm really busy and don't have time to meet up with a friend.
I need to do a proposal for a new client
I am on a diet and I have to go to the gym
I have to go to the gym and I don't have time to go to the gym
I have to go to my mothers house to take care of her who is a paranoid schizophrenic
I have to watch my dog who is a murdering psycho-neurotic 
I have to spend time with my daughter who is upset because she didn't get a place in college and she's having a mass of issues with her boyfriend
I have to go to my son's soccer game with my ex-wife who I haven't seen in over three months
I have to go to the bank and deposit $7000 into my account so that I can apply for federal student aid because the state cut our funding for our public school district
I have to go to the police station because the detective wants to speak with me regarding felony charges of child pornography possession and distribution
I have to buy an extra large coffee so that I can take it back to my office and take a dump in it
I have to go to the store and buy all of my christmas gifts so that I can buy all of my
I have to go to my accountant's office to get a mortgage for a house I am buying
I have to see a doctor because I got a letter from the federal government about the clinical trial I am enrolled in.
I have to make dinner for my family because we don't eat at the same time anymore.
I have to go to my mother's house and pick up her medication because she forgot to take it and she is an idiot.
I have to get my friend harry a birthday present because he is such a nice man who has been so good to me.
I have to go to the bank and a name some people as witnesses for a will
my husband needs some lumber for the new bed he built and I have to drive over there and get it
my daughter is coming over for dinner and needs her hair
I have to go to the shop to get a new drill bit
I have to take my daughter to the store to buy us some groceries
I have to pick up my daughter from school
I have to take my daughter to have her teeth cleaned
I have to go play golf with my friends
I have to go to the dentist
I have to go pick up my daughter from school or day care
I have to go pick up my daughter from day care
I have to take my daughter to the store to buy us some groceries or a new outfit
I have to take my daughter to the store to buy us a new
I have to go work on my friend harry's house because he's an idiot
I have to be a volunteer at the local animal shelter because the shelter is having a special sale on cats
I have to go to the bank because the check I wrote for my mortgage payment is not clearing
I have to pack my mother-in-laws clothes because they are going on a trip and they don't like the way she smells
I have to stop my mother from tearing up the house because she is mentally unstable so she keeps breaking everything
I have to take my daughter to the dentist because her teeth are falling out
I have to call my irs agent because they are going to call me about my tax return
I have to go to the store because I need milk, bread, eggs, and a dozen eggs
I have to go to the doctor because my son broke his arm and he needs stitches
my client got in to a car accident this morning and is asking me to get him a new laptop.
I have to call my friend george to deal with a problem at work. he is an idiot.
my colleague is having a birthday party and I have to be there.
I have to go to the doctor because I have a high fever.
I have to take my son to soccer practice.
I have to go to the movies with my friend.
I have an appointment with my doctor.
my wife is having a baby in two weeks and I have to take her out shopping.
I have an appointment with my doctor about my wife's pregnancy.
I have to organize my friend's basement because she has a party on friday
I have to organize my friend's basement because her husband left her and she is now in rehab and is an alcoholic
I have to organize my friend's basement because her husband left her and she is now a cabana boy
I have to organize my friend's basement because she is an alcoholic and she has a website called "cabana boy"
I have to go to the grocery store because I need to buy milk for my son and I forgot.
I have to take my son to the doctor because he's sick.
I have to go to the state capital because I have to vote.
I have to go to the home office because the boss is being an ass.
my husband needs his belt tightened.
I have to go to the vet's office because my dog needs a shot.
I have to feed my cat because he's hungry.
I have to do my laundry because I am cold
I have to go to the store to get some milk
I have to go to my friend's house for a video game tournament because my son is a champion in that game
my husband is coming home from work early because he has a bad headache
I have to go to the dmv because I forgot to renew my license
I have to get some new clothes because I wore out my old ones
I have to get the car washed
I have to get the cat neutered
my husband is coming home from work at midnight because he has a meeting to attend before he goes to work
I have to do my laundry
I have to pick up my daughter from soccer practice when we are late
I have to get some groceries because our power went out
I have to make a cake for our friend's wife's birthday
I have to go to our church's annual fundraiser
I have to go to the gym because my bad shoulder hurts
I have to go to the gallery opening for our friend who is a museum curator
I have to go to a conference for my job
I have to go to the bar because I love making people laugh
I have to go to the dentist because my teeth hurt
I have to go to the store because my husband forgot our anniversary gift
I have to go to the greek festival for our church this weekend
I have to go to my grandma's house
my friend has to have a baby and I'm trying to help her through the process.
I have to see my lawyer because I have been sued for being a racist asshole.
I have to see my daughter because she is pregnant and I forgot to tell her
I have to buy a christmas present for my wife's mother because she is getting a new bra
I have to buy a christmas present for my wife because she is getting a new bra.
I have to buy a christmas present for my mistress because she is getting a new bra.
I got rejected by my son for the fourth time in a row.
I have to find a new job because my current employer is a fraud
I have to go to the wedding of a very good friend of mine because it's at a restaurant that's a member of the committee for the world cup in brazil and I need to meet people.
I need to clean out my closet as it's 1) full and 2) has clothes that have been there for years that I never wear.
I have to do the laundry because I'm expecting a package from my mom's.
I have to make an appointment with the plastic surgeon to get a facelift for my aging face.
my sister sarah is coming over for the rest of the week because her mom is sick and sarah is staying with me for a while.
I have to take the dog to an appointment with the vet.
I have to go grocery shopping because I need to make dinner for my husband, our two children and my mother.
I must go to the gym because I'm getting too fat and it shows on my face.
I have to schedule a meeting with my partner who just got promoted and moved to a different country
I have to go to my gym
I need to go pick up my kids from school
my boss got a new dog
I have to get my hair cut
I have to go to the bank to get cash for the day
I have a meeting with the director of human resources
I have to meet my boss at a bar
I have to babysit my niece because her mom is working
I have to get my sister a birthday present
I have to pay my electric bill
I have a meeting with my mentor
I have to work out at the gym
I have to buy my dog a new leash
I have to pack for vacation and send it out
I have to get coffee with my friend
I have to make dinner for my parents
I have to get a haircut
I have to go to the dentist for a cleaning
I have to go to the emergency room for a broken wrist
I have to get tickets for my favorite band
I have to buy tickets for my parents birthday party
I have to go and purchase stock for a business opportunity I am going to start
I have to go christmas shopping with my parents
I have to go christmas shopping with my friends
I have to go christmas shopping with my friend
I have to take care of my mother who is in the hospital
I have to take care of my brother who has a fever
I have to take care of my sister who has a broken leg
I have to wash my car because it has a huge car wash sticker on it.
I have to take my ex-boyfriend to a family reunion
I have to take my dog to the vet again
I have to make all the arrangements for a party at my house. I also have a pool party that I need to plan.
I have to make sure that the pool guy is going to show up on time.
I have to take my dog to the vet again.
I have to go to the airport and drop off my friend who is flying in from out of state. 
I have to get my kids ready for bed because it's bed time
I have to put the dog to sleep because he is sick
I have to get my kids ready for scouts tomorrow morning
I have to go to the bank and deposit the check I just received
I have to move all my files and files to my new office
the elevator broke down and I have to go down 2 flights of stairs
I have to pick up my son for a soccer game
I have a meeting with a client about her new strategy
my son broke down the door and is destroying the house
my son is in a car accident and has to be rushed to the hospital
my son is playing soccer and has to be picked up by his team
I have to go get my favorite cupcakes that my neighbor made for me
I have to rotate my tires again because I had an accident yesterday
I have to go out to dinner with my wife
I have to go to the gym
I have to take out the garbage
I have to pay my bill
I have to pay my mortgage
I have to buy a new blood pressure monitor
I have to buy milk
I have to go grocery shopping
I have to renew my driver's license
I have to bring my sons back from basketball.
I have to take the kids to the movies
I have to take the kids to the beach
I have to take my daughter to her dance recital
I have to take the kids to their friends house for a sleepover
I have to take my son to football practice
I have to take my son to baseball practice
I have to take my daughter to cheerleading camp
I have to take my son to karate
I have to take my daughter to gymnastics
I have to take my son to soccer practice
I have to take my daughter to piano lesson
I have a family dinner at my in-laws house
I have a family dinner at my parents house
I have a family dinner at my friends house
I have a family dinner with my husband's parents
I have to go to a meeting at the firehouse tonight about the new paint truck
I have to go to a meeting at the firehouse tonight about the new paint truck.
I have to make a list for my friend karen who is having a baby
I have to get some clothes for my daughter's dance recital
I have to cancel my appointment with my personal trainer because I have to work overtime
I have to cancel my appointment with my therapist because I am too stressed out
I have to cancel a date with my husband because he is giving me the silent treatment
I have to cancel a date with my mother because she is dying of cancer
I have to cancel a date with my brother because he is quitting his job
I have to cancel a date with my sister because she is fighting with her husband
I have to cancel a date with my father because he is dying of cancer
I have to cancel a date with my daughter because she is sick
I have to cancel a date with my dog because she is sick
I have to cancel a date with my cat because she is sick
I have to cancel a date with
I have to put together my mom's birthday present for her
I have to do a birthday party for my sister's cousin who is turning 12
I have to put together a gift basket for my brother's friend who is coming to visit
I have to do my laundry
I have to do my taxes
I have to get my car inspected
I have to get my car serviced
I have to take care of my cats who are sick
I have to take care of my dog who is sick
I have to take care of my dog who is dying
I have to take care of my cat who is dying
I have to take care of my cat who is pregnant
I have to take care of my cat who is blind
I have to install a new kitchen for my wife who is about to give birth
I have to do something about the new nickname I got from my boss. 'fucking nga'
I have to make my daughter's science project for school
I have to put together a birthday party for my daughter
I have to make a powerpoint presentation for work
I have to get an oil change
I have to go to the bank
I have to pick up my son from school
I have to get my daughter a christmas present
I have to pick up my nephew at his soccer game
my friend would like to go for coffee
I have to help my friend move
I have to buy a gift for my friend's birthday
I have to take my friend out for dinner
I have to buy some books for my classes
I have to register for a class
my friend would like to do something else
I have to go get some coffee my friend who is having surgery this morning
I have to go get coffee for my friend who is having surgery this morning
some other more serious reason
I have to make my weekly trip to the bank
I have to make my weekly trip to the post office
I have to go into work for a meeting
I have to take off my shirt and clean my fish
I have to go to the dentist
I have to get a new fish
I have to call my doctor and tell him I have food poisoning
I have to take a bunch of vacation days
I have to make a big decision
I have to get a haircut
I have to buy a new tv
I need to buy a new xbox 360
I have to make important decisions on how I am going to spend my raise
my daughter needs me to take her to her orthodontist appointment
I have to give my friend vernell a ride to the hospital for his wife who has just given birth
I have to do this errand and that errand and you are too hung up on the red sox
I have to decide whether or not I want to take my daughter to the prom
I have to ge the laundry sorted out
I have to make dinner for my partner and her new boyfriend who just moved in
I have to decide what movie we are going to watch tonight.
I have to finish my project for work
I have to make time for my kids because their teacher just told them that they have to make a presentation about their project and it needs to be done by friday.
I have to buy groceries for the week
I have to buy a new laptop because it is down
I have to take out the trash
I have to wash the dishes
I have to take my son to the dentist
I have to take my son to the doctor
I have to take my father to the doctor
I have to take my father to the hospital
I have to see a specialist
I have to see a doctor
I have to see a specialist in the morning
I have to go to the hospital
I have to see a doctor in the morning
I have to see a dentist in the morning
I have to take my father to the hospital in the morning
I have to buy groceries for
I have to take my daughter to the eye doctor (my daughter is blind)
my cat has to take his annual shot
I have to check to see if my plumber is finished with my basement and if not, why not?
I have to go back to my doctor's office to see if I can get a hysterectomy
I have to go back to the eye doctor in a few months because my prescription is supposed to be changed
I have to go to the dermatologist because of another tumor on my face
my friend jonie is dying of cancer and I have to take her out for dinner on tuesday.
I have to go back in on the 4th of july because my other eye doctor's is closed on the 4th of july.
how about I have to drive my mother to the doctor?
how about I have to drive my husband to the airport in 3 hours?
I have to finish this book I'm reading because I'm at a speed of about 6 pages a day
I am going to have to go grocery shopping because my cook just quit
I have to take my dog out for a walk because she crapped all over the living room
what about I have to go grocery shopping with my husband and the kids are fighting over something.
I have to read a book for my english class.
I have to buy more books for my english class.
I have to hang out with my friend because he is sick.
I have to go to the grocery store because my mom is cooking.
I need to go to the bank because I have $500 on my credit card.
I have to buy things for my girlfriend's birthday because she is a girl and girls like presents
I have to go see a movie with my friend
I have to clean my room because I spilled a bottle of wine on my bed.
I have to buy a new pair of shoes because I used them last night and I had no idea they were dirty
I have to go do some laundry because I spent the evening partying and my clothes stank.
I have to go grocery shopping.
I have to go to the bank to deposit the check I got from my investment company
I have to go to the gym
I have a date with my girlfriend.
I have to go to the office for a meeting
I can't wait to make sushi
I have to get my nails done
I have to get my hair done.
I have to get my teeth whitened.
I have to get my eyes checked.
I am going to the dentist
I am going to get my teeth fixed.
I have to buy groceries.
I have to buy a birthday present for my wife's birthday.
I need an iphone case.
I have to buy my daughter an outfit for school.
my daughter
I have to help my friend jules because she is having a hard time with her husband, and she needs me to help her with the kids while she goes buy her things at the mall.
I have to go pick up my daughter luz from school because she did not report to school last night, she spent the night with her boyfriend jorge.
I have to take my daughter luz to her friend's basketball game tonight because she forgot her own shoes at home.
I have to take my daughter luz to the dentist because she has a cavity.
I have to go pick up my daughter luz from her friend's basketball game because they are looking for her and she is late.
I have to go pick up my daughter luz from her friend's basketball game tonight
I have to take my brother to the eye doctor
I have to pick up my nephew from soccer
I have to see a client downtown
I have to go pick up my daughter from school
I have to see my husband
I have to give my mom her birthday present
I have to go grocery shopping
I have to see my nephew who is having trouble with his homework.
I have to return a book to the library.
I have to see a client because it is a follow up appointment on my hip surgery
I have to pick up my granddaughter from school. note: this was an old woman who could barely walk
I have to go pick up my daughter from school. note: this was a young teenager who was late for her bus.
I have to go pick
I have to go to work with my boss
I have to go to work with my boss and his wife
I have to go to work with my boss and his wife and his brother
I have to go to work with my boss and his wife, his brother and me
I have to go to work with my boss and his wife, his brother and my boyfriend
I have to go to work with my boss and his wife, his brother, my boyfriend and a friend
I have to go to work with my boss and his wife, his brother, my boyfriend, a friend and his wife
I have to do taxes
I have to run errands
I have to get coffee with my friend
I have to go on a date with a co-worker
my mom has her hair done
I have to pick up a pizza for bill who is in the hospital
I have to give a presentation at work
I have to buy a new piece of equipment for the job
I have to change the water filter in my pool after it got clogged
I have to take my mom to a doctor's appointment
I have to go to the mall as my husband forgot his wallet
I have to clean out my dvd collection because they aren't playing anymore
I have to meet my friend deliza for coffee
I have to do a wedding for my friend kathey who is dying of cancer
I have to pitch a screenplay that I'm trying to sell
I have to get all of my stuff for the wedding I'm catering
I have to do a fundraiser for the pta
I have to organize a school fundraiser
I have to work a double shift for the charity
I have to do the majority of my friends' taxes for them
I have to go grocery shopping for my family
I have to pick up my son from school
I have to finish my 3 year project
I have to look over my mother's medical records and find out what is wrong with her
I have to go on a planned vacation with my family
I have to take care of my elderly grandmother who is not doing well any more
my waitstaff is constantly talking and they never listen. I'm going to let them go.
it's time to file
I have to go to the furniture store to buy some new office chairs
I have to go to a funeral
I have to go to a meeting for the local singles club and they are not very nice people
I have to go to a meeting for the local women's book club
I have to go to a meeting for the local african american book club where they talk about hair and makeup and clothes and one of the members is constantly talking about some guy who gave her a ride home from the airport
someone called and wants me to go look at a new car
I have to go to a meeting of the local motorcycle club
someone called and wants me to go look at a new house
I have to go to a meeting for the local soccer club and they are not very nice people
my friend is leaving town on vacation and
I have to go home and pack for my move
I have to go home and get ready for my vacation
I have to take care of my sick nephew who has a fever of 105.
I have to fill out college financial aid forms
I have to pay my cell phone bill
I have to call the mortgage company
I have to get my sister's will done
I have to get my daughter's braces taken out
I have to buy a gift for my boss
I have to get my brother's birthday gift
I have to call my brother's wife about the divorce hearing
my friend tiffany died
my sister called and said she's on her way to the hospital
my nephew is sick
my boss is being unreasonable
my friend is being unreasonable
I need to get a gift for my boss
I want to get a gift for my boss
I have to get a gift for my friend who is dying of cancer
I have to find a copy of my masters thesis
I have to buy a new pair of shoes for work
I have to go to a bar with my friend marissa that she is taking me to
I have to go find my friend yvonne who is in the hospital
I have to go to myeongdong and buy my friend lee his birthday present
I have to look for my friend laura who is hiding from the police
I have to go buy my friend lee a birthday present
my friend wants me to show her a new movie
I have to go to the emergency room because of a headache
I have to go to the dentist because I have a toothache
I have to go to the bathroom because I need to pee
I have to go home because I'm tired
I have to take my dog out because it's raining
my friend wants me to help her move
I have to help a friend move
my friend hila wants me to watch her
I have to watch a documentary on the history of france
I have to get a haircut
I have to apply for a job that requires me to be in a new city by a certain date
I have to tell my family that my sister is getting married
I have to get my hair trimmed
I have to buy a dress for my friend's wedding
I have to get an engagement ring for my boyfriend
I have to make an appointment with my doctor for an annual check-up
I have to buy lunches for all of my co-workers' meetings (I'm their boss!)
I have to put up posters at my college's career fair (that's in three days!)
I have to finish three projects and turn them in at the end of the week
I have a meeting to go to
I have to go to my friend's house because they just had a baby and I want to see the new addition
I have a meeting to go to about a business opportunity that I want to invest in
I have an absolutely incredible opportunity to be the face of a new product at an upcoming fashion show
I have to go to a fundraiser for the children's hospital
I have an anniversary dinner party that I absolutely have to attend
I have a dinner party at my apartment that my friends are over and I really don't want to be there
my friend floy just got married and we are having a dinner party this weekend for her and her husband
my friend floy just got engaged and next week we're having a dinner party for her and her fiance
I have to help my wife with her resume for her new job which is going to happen in january
I have to design and build the new garden shed for my wife's birthday party
I have to answer e-mails from my wife and my sister-in-law who are in the middle of a divorce
I have to buy my wife a new computer because her old one is broken
I have to watch my nephews and nieces because their mother is in the hospital
I have to go to the post office because their are two packages for me
I have to go home because my wife is getting sick again.
I have to go to the hospital because my wife is dying of cancer.
I have to go to the post office because there's something in my mail box.
I have to finish this pattern for that project
I have to take my dog to the vet
I've got a blood test in a few minutes
I need to make a phone call
I've got to make a barbeque in my backyard tonight.
I have to do a quick shopping trip for clothes I want to wear for 2.5 weeks in a row.
I have to start a new job. I need a new office space.
I have to get ready for a party. I have to change my outfit 5 times.
I have to prepare for a dinner party that I am giving to my boss
I need to find date to a party that I am giving my boss and his wife.
I have to make dinner for my husband's friend.
I have to make dinner for my husband and the people who will be attending his birthday dinner.
I have to make dinner for all of my friends.
I have to make an appointment with my psychologist
I have to make an appointment with my dermatologist
I have to go on a date with my boyfriend
I have to finish reading a book that I am reading.
I have to write a letter to my lawyer
I have to go to a meeting for the board of my health insurance co.
I have to spend an hour in the car with my kids and my husband and we get into a fight
I have to go to the gym and do a workout
I have to do an interview on my passion for art
I have to go to the airport because I need to pick up my daughter from camp
I have to do a presentation at work
I have to go grocery shopping
I have to read a book
I have to go to the dmv
I have to get my hair done today
I have to go and pick up my friend at the airport
I have to research for an article I'm writing on the topic of "how to make the perfect steak"
I have to organize a charity event
I have to go get my nails done and my hair cut
I have to go pick up my daughter from school
I have to go buy groceries for dinner that night
I have to go to the dmv to get my drivers license renewed
I have to go pick up my daughter from school for an hour long after school activity
I have to go pick up my daughter from school for an hour long after school activity while she's not feeling well
I have to go pick up my daughter from school for an hour long after school activity and she's having a meltdown because she doesn't want to go anywhere
I have to plan an engagement party for my best friend and her fiance
I have to plan a wedding shower for my friend and her soon-to-be husband
I have to plan a wedding shower for my mother's friend and her soon-to-be husband
I have to plan a birthday party for my best friend and her boyfriend
I have to plan a birthday party for my cousin's fiancé
I have to plan a birthday party for my best friend's daughter and her boyfriend
I have to plan a birthday party for my husband's brother and his girlfriend
I have to plan a birthday party for my husband's sister and her husband
I have to plan a birthday party for my wife's sister and her husband
I have to plan a birthday party for my wife's mother
I have to a work meeting with my boss
I have to a meeting with my client
I have to a conference call with my accountants
I have to a meeting with the sales team about the new project
I have to a meeting with the marketing team about the new project
I have to a meeting with the sales
I have a huge presentation on the economy to make to my boss and I have to do it on a projector
I have a date with my boyfriend and we have to go to the movies for a romantic comedy
I have a 4:30 appointment with my personal trainer and I need to get there by 4:15
I have an essay due for my creative writing class tomorrow that I haven't started
I'm going to the mall and I need to buy some new clothes
I'm going on a road trip with my friend and I need to stop at the mall to buy snacks for the car
my mom is coming home for the weekend and she has to pick up her car from the repair shop
my father just
I have to go to the gym!
I have to stop by the dmv to renew my driver's license.
I have to go to the dmv to renew my auto insurance.
I have to go to the dmv to renew my car registration.
I have to go to the dmv to renew my car inspection.
I have to go to the dmv to renew my car tags.
I have to go to the dmv to renew my car's license plate.
I have to go to the dmv to renew my car's registration stickers.
I have to go to the dmv to renew my car's license plates.
I have to go the dmv to renew my car's tags.
I have to renew my car's inspection.
I have to renew my car's registration.
I have to babysit my nephew and his friend
I have to babysit my nephew and his friends
I have to babysit my nephew, his friend, and his friend
I have to babysit my nephew, his friend, his friend, and his friend
I have to babysit my nephew, his friend, his friend, his friend, and his friend
I have to take my favorite niece to the zoo
I have to take my nephew to the zoo
I have to take my niece to the zoo
I have to go to the zoo
I have to go to pick up my nephew
I have to go pick up my niece
I have to go pick up my nephew
I have to write the next chapter of my novel
I have to write a paper for my literature class
I have to write a blog post for my personal blog
I have to write a letter to my ex
I have to get a new pair of shoes for the gym
I have to help my friend with her son's homework
I have to review my resume
I have to call back those people who called me recently
I have to do some laundry and make dinner for myself
I have to finish the chapter I've been writing.
I have to get my boys ready for their piano lesson.
I have to take my dog out for a walk
I have to make a coffee date with my friend who is always late.
I have to go to a meeting about my thesis
I have to study for my pathoma exam
I have to make homework for my ap physics class
I have to go to the grocery store and buy a present for my boyfriend
I have to edit a movie I made about my life
I have to finish my thesis
I have to take my chemistry test
I have to put a load of clothes in the washer
I have to make my son a birthday cake
I have to finish my book
I have to meet with my friend about what he wants at his wedding
I have to cook and serve my mates a birthday cake.
I have to watch my friend play guitar and sing a song and I'm supposed to be taking photos
I have to cook a roast dinner for my boss
I have to go to the doctor
I have to buy some chocolate for my wife
I have to pick up my nephew from school
I have to do my taxes.
I have to cook dinner for my wife and daughter
I have to buy a new parka for my brother-in-law
I have to watch my nephew play football
I have to go and see a lawyer about a problem I'm having
I have to make a cake for my wife's birthday party
I have to make dinner for my sister-in-law and her son
I have a meeting at a local theater company and I need to help with a play that's supposed to be fairly popular but it's being put on with really no rehearsal time.
I have to teach my students a new lesson.
I have to fill in for the substitute teacher for the last week of school because the regular teacher can't make it for the full week.
I'm supposed to rehearse for a play but I can't find the script I need, so I have to make up one on the spot.
I need to deliver a speech to an organization that I'm a member of.
I have a meeting with my boss about a big project that I'm trying to get off the ground.
I have to go to court for jury duty but I can't remember
I have to pick up my son from daycare
I have to drop off my daughter to daycare
I have to pay my light bill
I have to take my daughter to the dentist
I have to make a small purchase at the grocery store
I have to get a haircut for work
I have to pick up my son from school
I have to set up a workout session for my son
I have to pick up my daughter from school
I have to pick up my son after work
I have to get my daughter ready for bed
I have to make dinner
I have to do laundry
I have to pick up my son from dance class
I have to go somewhere with my friend
I have to take my son for a haircut and get his ears
I have to make my bed.
I have to go to the post office to pick up my paycheck.
I have to make the bed.
I have a big presentation tomorrow at work for which I have to prepare.
I have to make a presentation about what I've learned from my trip to peru and spain
I have to go see my therapist about my mother
I really need to start taking care of my diet
I have to run to the post office to pay my bills.
I went to get the new iphone 4 and I forgot my cash.
I have to go to the jewelry cleaner and get my earrings fixed.
I have to make a call to the florist because I forgot to order my flowers.
I have to go to the bathroom
I have to clean my apartment
I have to watch a movie
I have to write a blog post
I have to take a shower
I have to watch tv
I have to eat
I have to finish a game of chess I'm playing with my friend jamee
I have to help my friend jamee move
I have to take care of my dog
I have to see my mother for lunch
I have to make dinner for jamee and his girlfriend 
I have to go see my friend jamee because he is having problems with his computer. 
I have to go pick up my dog from the pound. 
I have to pick up my daughter from school because she is in trouble for cutting class.
I have to work out but I'm not going to, I'm going to watch tv instead.
I have to make a new business card for my new job
I have to make a birthday cake for my friend's daughter
I have to buy a lottery ticket
I have to take my son for his shots
I have to make a doctor's appointment for my father
I have to take my daughter to her ballet lesson
I have to make an appointment with a financial advisor
I have to go to the dentist for a cleaning
I have to pick up my son from soccer practice
I have to go to the dmv for my license renewal
I have to go to the police station for a background check
I have to meet a friend for lunch
I have to go to the bank
I need to make a new resume for a job opening
I have to change the bed
I have to go to the gym because of my diet
I have to go to the dentist
I have to help my cousin move
I have to clean my house before my friend jamee comes over
I have to make a list of what I need to take to work
I have to do my taxes
I have to go to lunch with my friend jamee
I have to go to a meeting with my boss and my friend jamee and I can't think of anything interesting
I have to take my friend jamee shopping
I have to go to the doctor because my tooth hurts
I have to take a shower because I stink
my friend jamee and I need to talk about the relationship we've been having for six months
I have to watch my youngest son's hockey game
I have to play in a squash league
I have to leave the office 10 minutes early because I'm going to a wedding
I have to get my hair cut
I have to go to a meeting
I have to get my nails done
I have to paint my house
I have to get my car serviced
I have to see my bank manager about an important loan application
I have to go get a blood test because I'm taking my youngest son for a checkup at the pediatrician's office
I have to bake a cake for a friend's birthday
I have to change the batteries in the smoke detector
I have to take my dog for a walk
I have to clean the cat box
I have to go to the mall and buy a new pair of shoes for work
I have to go to the gym
I have to go shopping for a new pair of shoes
I have to watch the olympics
I have to go to the bank
I have to run errands
I have to watch the oscars
I have to get my taxes done
I have to go to the dentist
I have to go to the grocery store
I have to get my car inspected
I have to make reservations at a restaurant
I have to make a doctor's appointment
I have to go to work
I have to do the laundry
I have to drive my kids to their piano lessons
I have to make dinner plans with friends for this weekend.
I have to take my daughter to her dance class
I have to do some shopping for
I have to work on a presentation for my boss
I have to look at job ads
I have to look at résumés
I have to look at portfolios
I have to design a website for my company
I have to make a plan for my schedule the next day
I have to work on my resume
I have to write a letter to my boss
I have to find a new eye doctor
I have to find a new doctor because my current one is moving out of state.
I have to buy a new vacuum cleaner and do the housecleaning
my cleaning lady is out sick and I have to get the house cleaned again.
I have to pay bills and make sure everything is paid by the date that it is due.
I have to pay bills
I have to do an audit of our company's financials, and I've been avoiding it for a year
I would like to take my girlfriend to the movies, but I don't have enough time because I'm going to make dinner for my kids and I want to go out again with my friends
I need to apply for the position of director of refuse and recyclable material collection for our company
I'm going to the beach with my family, but I need to go get a new swimsuit because my old one is falling apart
I'm going to put in a new carpet because my old one is disgusting
I need to find
I have to go attend a summer class that I've committed to
I have to be on a conference call with someone in new york and I'm worried because the person who should be on the call is out of town
I have to go to my parents house for dinner and my mom is cooking a wild boar that we're supposed to share
I have to meet my friend for coffee right now because she's in town visiting and I'm supposed to give her a hug 
I have to get all my stuff ready for the beach because we're going for the weekend
I have to buy a new computer because I got a virus
I have to book my flight for the island
I have to get my nails done
I have to clean my house
I have to eat lunch
I have to go to the store
I have to tidy up
I have to write the script
I have to pick up my daughter from school
I have to finish a book that I'm working on.
I have to listen to a huge piece of music that I'm working on
I have to listen to music that I'm working on
I have to go shopping for a baby gift and I'm supposed to be done by 4pm
I have to finish a piece of work that my boss has given me.
I have to work on a big project that my boss has given me.
I have to clean out my garage.
I have to call my friend in richmond/virginia to find out if she wants to get together for a late night dinner
I have to pay the electric bill in two days and my credit card company is threatening to put a block on my account
I have to go to church and preach a sermon that is not only timely but also really well written and not too long
I have to put up a 33×33 board in my church which is only 4 feet by 4 feet in size and which I have been working on for four months
I have to call my best friend and ask if she wants to have coffee with me. I've been meaning to for several weeks now
I have to go to the carnival and play a game that requires me to be able to ride a bike without falling over.
I have to a lunch meeting of the american society for engineering management
I have to a meeting of the national association of engineering women
I have to a meeting of the national association of locomotive engineers
I have to a meeting of the national railway enthusiasts
I have to a meeting of the transportation management association
I have to a meeting on the future of rail transportation in america
I have to a meeting of the national railroad historical society
I have to a meeting of the association of american railroads
I have to a meeting of the ohio railroad historical society
I have to meet the curator at the art gallery and look at some of her new pieces
I have to buy a new pair of shoes for my son so they are ready for his school
I have to go to the hair salon and get my hair done
I have to make an appointment with the accountant to sign the tax return
I have to go see a therapist because I'm so depressed
I have to get a haircut
I have to a dinner party for my friend minna and I'm supposed to cook a chicken
I have to a dinner party for my friend minna and I'm supposed to cook a beef. I can't because I'm allergic to beef. 
I have to a dinner party for my friend minna and I'm supposed to cook a chicken. I can't because my husband is allergic to chicken. 
I have to a dinner party for my friend minna and I'm supposed to cook a
I have to buy a new pair of shoes for work
I have a meeting in an hour with my boss which he asked me to attend
I have a meeting in an hour, I'm supposed to meet my friend at this new bar he told me about
I have to buy new shoes for work
I have a meeting and I'm supposed to meet my friend and his significant other at this new bar he told me about
I have a meeting and I'm supposed to meet my friend for lunch
my friend asked me to go play golf with him and his new bride and I have to drive from barrie to ottawa
I have to go to this lecture on saturday.
I have to run errands on monday.
I have to call my friend sheila on tuesday
I have to go to the store on wednesday
I have to do something "fun" on thursday.
I have a proposal due tomorrow.
I have to read a text message from a friend.
I have to take a nap.
I have to go to the bank to take out some money for my trip to philadelphia
I have to go to the bank to withdraw some money so I can pay the bills
I have to buy our new vacuum cleaner because felicitas liked the one we just bought and she wants a different color
I have to buy a new vacuum cleaner because felicitas likes the one we just bought and she wants a different color
I have to get to the office early for my meeting
the babysitter is sick
my wife has some errands to run
my 8 year-old son wants to go to the movies, we can't refuse.
I have to run out to the store to buy some milk 
I have to run to the nail salon and get my eyebrows waxed
I have to get my hair highlights
I have to take my parents in for a photo shoot
I have to get my driver's license renewed and take my dad's car
I have to get my little brother's college acceptance letter
I have to get my roommate's cat neutered
I have to make dinner for my co-worker's birthday party.
I have to make dinner for my friend's birthday party
I have to make dinner for my aunt's birthday party
I have to take a friend to the airport
my mom wants me to take her grocery shopping
my mom is coming over for a surprise visit.
my tire needs to be replaced
I'm going to a party at my friend's house for some reason
I have to pick up my wife from the airport
I'm getting a massage
I have to meet my friends at the bar after work
I have to buy a new computer
I have to buy a new car for work
I have to buy a new tv
I have to buy groceries
I have to buy a new camera
I have to buy a new printer
I have to buy a new microwave
I have to buy a new bed
I have to replace the kitchen sink
I have to find someone as well qualified as me for a job that I've been trying to fill for months
I need to replace my wife's car because it's going out of warranty
I need to replace the spare tire because the spare has a flat
I have to get my teeth cleaned
I have to go grocery shopping for the upcoming week
I have to get my wardrobe organized
I have to unpack most of my stuff from my last trip to london
I have to go to the bank
I have to get my car serviced
I have to take the trash out
I have to take the dog out
I have to take the cat out
I have to take the fish out
I have to get my hair cut
I have to get a new winter coat for my husband
I have to get my teeth cleaned again
I have to take the dog out again
I have to take the fish out again
I have to take the cat out again
I'm supposed to take an hour to go get a haircut
I have to get my hair done
I have to get my annual checkup and blood pressure check
I have to take care of the house
I have to take care of the yard
I have to get my car inspected
I have to go to the office and finish that spreadsheet
I have to go to the gym and get my workout done
I have to get my investments done
I have to take care of my investments
I have to go find a tax attorney and document my deductions
I have to go to the grocery store
I have to do laundry (and dry cleaning, and ironing)
I have to get my taxes
I have a dinner party for my aunt and I need to make the salad and shop for the wine
I have to buy a gift for my aunt for her birthday
I'm supposed to give a presentation to my company on how I use social media and they want me to be prepared.
I need to coordinate a few things for my son's birthday party
I have to go to a tailor and get fitted for an important meeting
I have to go to the dry cleaners because of a stain on my pants
my mother-in-law is coming over for dinner this week
I'm having a dinner party at my house and need to get some party supplies like napkins, plates, and wine glasses.
my boss wants me to make a presentation on the new tax code changes that took place.
I have to take my nephew simeon to the dentist because he has a toothache
I have to finish a poem that I've been working on for a week
I have to finish reading the book I'm reading for class
I have to get my hair cut and colored at the same time because I'm going on vacation
I have to get the house organized before I head off to work
I actually do have to go to the gym and work out
I have to finish my taxes and figure out what I'm going to do with my tax return
I have to write a blog post about the wildfires that have been going on for the past month
I have to find a replacement for my friend hilde as our school's diversity officer
I have to write about the wildfires and how they effect my town, my community, and the people I know
I have to figure out why my friends' cats are obsessed with my cat and why my dogs won't stop barking
I have to attend a meeting in the morning.
the babysitter called and I have to take them to the park.
I have to take a shower because I'm so dirty.
I have to make some tea and get ready for work.
I have to pick up my son from school.
I have to make a dinner party for 5 people.
I have to get my son ready for bed.
I have to do some shopping.
I have to go to the library.
I have to run an errand.
I have to go to the gym.
I have to do some laundry.
I have to go to the post office.
I have to buy groceries.
I have to take my daughter to gymnastics class.
I have to go to the gym
I have to take a nap
I have to make a list of all the people I owe money to to pay off my credit card.
I have to find a new office for my business because I've just moved to a new building
I have to get the office door fixed because someone keeps leaving it open causing me to distract myself with other work
I have to send a letter to a client who hasn't paid me
I have to deal with a customer who is being difficult
I have to take my boss to lunch to try and resolve the issues we've been having. I have no idea what the issue is but I feel like talking about it might help
I have to find a new job because this company doesn't want me any more
I have to get the baby's clothes washed and put away so they don't get lost
I have to make a new cake for my friend's birthday
I have to find a new job
I have to print out this document
I have to go to the pharmacy
I have to take my dog for a walk
I have to make a new website
I have to start this blog post
I have to do the dishes
I have to do laundry
I have to make a new cake for the bake sale tomorrow
I have to go grocery shopping
I have to buy eggs for tomorrow's cakes recipe
I have to go to the bank, and bring my checkbook with me.
I have to make a new soup recipe for the bake sale tomorrow
I have to show a client 3d rendering of the packaging they are going to use
I have to make sure that my friend's daughter sara doesn't get into trouble and that she gets home by midnight.
I have to go to the dentist for a cleaning and a checkup
I have to meet with a new client
I have to run an errand
I have to get my hair cut
I have to go grocery shopping for the week
I have to clean my house
I have to pay my bills
I have to go to the gym
I have to get my nails done
I have to do the taxes
I have to apply for a new job
I have to take the kids to soccer practice
I have to pick up my dry cleaning
I have to go to my bank.
I have to pick up my dry cleaning again.
I have to take the kids to ballet
I have to make dinner.
I have to buy a new dress
I have to arrange to have my car serviced
I have to go to the doctor for a checkup
I have to buy a new pair of shoes for my date
I have to make an appointment with the hairdresser
I have to write two more blog posts
I have to make a doctor's appointment for my mother in law
I have to make some calls for a friend who is suffering from depression
I have to make some calls to people who need financial advice
I have to arrange to go on a plane
I have to figure out how to pay my rent
I have to solve my car insurance problem
I have to arrange to visit my sister in bend,
I have to take my son to the eye doctor
I have to go to the gym before work
I have to take my dog to the vet
I have to go to my dermatologist about a skin condition I'm having
I have to go to the doctor about my blood work
I have to go to the grocery and get more dog food for my dog
I have to go grocery shopping because I'm having a party and I need to get the food
I have to go to the coffee shop because my friend and I want to get coffee but we both are incredibly busy.
I have to go grocery shopping because my friend is going to be here in 20 minutes and we are supposed to get coffee but we can't because of our schedules.
I have to get my son a gift for his birthday
I have to make dinner for my husband at the last minute because of a business trip
I have to have dinner with my parents
I have another meeting at the white house in relation to international climate change
I am going to the gym tonight
I'm supposed to go to a baby shower
I have to go to the lab and talk to a new postdoc
I have to go to a party
I have to go to a job interview
I have to go to a meeting with a client
I have to be on call
I have to be at the hospital for an emergency
I have to do a critical mass for the club
I have to do a presentation for my professor
I have to finish grading a final draft of my novel.
I have to grade a final draft of my novel.
I have to pitch a screenplay that I'm trying to sell
I have to a dinner party for my friend
I have to go to the dentist this afternoon to have a root canal and I don't have my dental insurance
I have to get my teeth cleaned 
I have to get my teeth cleaned and meet my friend at the grocery store after
I have to get my teeth cleaned, make sure the dog is fed, get my teeth cleaned,
I have to go help my friend kate with her research project on the importance of sleep and how it affects memory loss
I have to meet my friend at the train station because she's on her way to her parents' house
I have to go to the movies, the grocery store, the mall and the liquor store
I have to see a friend to discuss my career
I have to go to a movie with my sister
I have to get a haircut
I have to get a job
I have to go home and get ready for an important business dinner
I need to go see my daughter (she's grown and gone now, but I still miss her)
we are going on vacation to a place where I haven't been for 30 years - I can't just get up and go there on a whim
I have to do three loads of laundry
I have to make something
I have to go to a party for my friend mr. rogers
I have to take my daughter to a piano lesson
I have to go to the doctor for a surgery for my friend mr. rogers
I have to pick up my daughter from her piano lesson
I have to pick up my friend mr. rogers from the opera
I have to pick up my son from his piano lesson
I have to organize and decorate my son's coming out party.
I have to make a new dress for myself
I have to go on a date with my friend paul
I have to see my doctor
I have to go to the dentist
I have to prepare for that week's meeting in my business
I have to leave early in order to pick up my son from school
I have to go on a weeklong trip with my husband
I have to plan a trip for the summer vacation
I have to plan a trip to the dominican republic for me and my husband.
I have to take my son on his first camping trip
we have the grand opening of our new business so I have to make sure everything is perfect.
I need to pay a mortgage payment and I have no money
I have to pick up my daughter from preschool
I have a doctor's appointment that I can't reschedule
I have to buy a gift for my mom's birthday
I have to buy a gift for my dad's birthday
I need to buy new pajamas for the winter of 2014
I have a client coming in to take care of her dog for a week
I have to make a pitch for a new campaign
I have to clean up my house because the water got turned off
I have to order some parts for my car
I have to go to the gym and run on the treadmill because I'm too lazy to go outside and jog
I have to meet my friend for coffee before work
I have to meet my friend at the coffee shop before work
I have to get a manicure
I have to get a pedicure
I have to get a colonic
I have to meet my friend for lunch
I have to meet my friend's mother for lunch
I have to meet my friend's mother for lunch then I have to go home and do laundry.
I have to meet my friend's mother for lunch then I have to go home and
I have to fix a leaky roof in my basement and I won't be able to get there
I have to take a dog for a walk
I have to clean the house. 
I have to write up an article on the difference between a schist and a gneiss
I have to host a book club meeting.
I have to host a dinner party for a client.
I have to attend a presentation on how to write a novel.
I have to make a retirement party for my brother
I have to make an anniversary gift for my daughter and her boyfriend
I have to make a birthday gift for my mother
I have to make a gift for my wife's cousin's family
I have to make a gift for an eighty year old friend of my mother's
I have to make a birthday gift for my ex-wife
I have to write a letter to my grandmother
I have to write a letter to my sister
I have to write a letter to my brother-in-law
I have to write a letter to my high school principal
I have to write a letter to the school principal
I have to write a letter to the senate in order for my bill to pass
I have to write a letter
I have to go to the doctor because I have a fever from the flu
I have to do laundry because my girlfriend is coming for a visit
I have to pick up my son from school
I have to pick up a bottle of wine from the store
I have to looking for my glasses in the kitchen (I do not wear glasses but I need them because I have a severe astigmatism)
I have to pick up my daughter from school
I have to make sure my daughter gets home from school safely
I have to make some money because I'm paying all my bills with credit cards and I'm behind on all my bills
I have to clean the house because my wife is away on vacation
I have to make sure my wife's mother-in-law is feeling better
I have to go to the bank this morning for a money transfer
I have to do some work for my job
I have to do some work for my boss
I have to call 6 people to confirm a meeting
I have to go on a date
I have to return a book to barnes and noble
I have to return a dvd to blockbuster
I have to return a book to amazon
I have to return a book to the library
I have to write a report for work that's due tomorrow
I'm supposed to help a friend with her taxes.
I'll have to cancel because I'm going to a wedding on saturday
I'm going to have lunch with a client who told me that he has some questions he needs to ask me about my investment strategy
I have to go to a dinner party that I'm co-hosting
I have to sell a painting that I've had in storage for 6 years
I have a meeting with an investor in 5 minutes
I have a meeting with my bookkeeper in 5 minutes
I have an e-mail from my accountant about an upcoming tax return
I have an e-mail from my bookkeeper about my financial statements
I have a voicemail from my accountant who wants to discuss the tax return with me
I got a call from my bookkeeper who wants to discuss the
I have to make it to the theatre on time
I have to keep up with my work schedule
I have to drive to toronto for a meeting
I have to buy a new pair of shoes for the dance.
I have to serve as a best man in my friend's wedding
I have to shop for a new computer
I have to paint a nude model
I have to drive home from work
I have to make it for the meeting in half an hour
I have to finish my presentation for work
I have to make it after work
I have to talk to my friends about my problems tonight
I have to do the laundry and iron
I have to make dinner for my husband and i
I have to make breakfast for my children
I have to talk to my brother about his problems tonight
I have to go see a play that I can't miss
I have to make it for the party
I have to go pick up my kids from soccer practice
I have to pick up my kids from karate, etc.
I have to go pick up my kids from violin practice
I have to get my friend to pick me up from the train station.
I have to take the subway a long way to pick up my friend and we're going to lunch.
I have to send out a press release for a new book I'm finishing 
the library needs a new computer system
I need to buy a new sofa
I have to teach the college class on sunday
I need to prepare for my classes at the university on tuesday
I have to teach the college class on wednesday
I need to clean my apartment
I have to buy groceries for the week
I have to pay the utilities
I need to get my hair cut
I have to buy clothes
I need to get my nails done
I need to go to the dmv for my driver's license renewal
I need to go to the barber for a haircut
I need to go to the mall for some new clothes for an upcoming work function. 
I have to make dinner for my boss and I have to learn how to make some kind of fish
I have to make brunch for my friend who is having a baby and I have to learn how to fry an egg
I have to take my kids to the doctor and I have to pick up one of the kids at the end of the day 
I have to learn how to make a quiche
I have to make dinner for my date with my husband and his friend aiden who are coming over for dinner
I have to teach a cooking class at my school for the school's general fund and I'm supposed to use the leftovers from my first class as an example
I have to take my kids to the doctor again and I need to pick up the other one
I have to drive up to the city to see my therapist
I have to go to the bank and deposit my paycheck
I have to go to the mall to buy a gift card for my son who is graduating from high school
I have to go to the mall to buy a gift card and I also need to buy something for my girlfriend who is being deployed to afghanistan
I have to cook a meal for my wife and I'm not feeling well so I'm taking a probiotic
I have to prepare a presentation for my boss and company tomorrow that will take about 3 hours
I have to cook a roast for my family tomorrow and I've just remembered I don't have the right size pot.
I have to host a charity poker tournament for a friend who's a cancer survivor
I have to pitch my screenplay
I have to attend a very intense magic: the gathering tournament
I have to a meeting at work that I have to get to in 10 minutes
I want to go out for coffee after work
I have to go to a concert tonight
I am working on my novel and I have to write three pages by 5:15pm
I have to attend a wedding tonight
I have to do a presentation at work that I haven't started yet
I have a date tonight with my wife
I have a family dinner tonight
there's a new magic the gathering expansion happening and I want to buy it all
I have to go to a party tonight and get hammered
I am going on vacation tomorrow
I am going to play magic the gathering
the company is going on a trip and I have to organize all the work.
I have to spend time with my daughter.
I need to bring home some work from work.
I have to buy some groceries.
I have to go to the store for a new computer.
I have to do a special dinner for my boss and his wife who are coming in from out of town. I should make some sort of meat dish.
I have to cook a dinner for my boss and his wife. I should make some sort of meat dish.
I have to go to a dinner party a movie with my boss and his wife. this will be the first time they've been to the theater together in years. I should cook some kind of meat dish.
I have to do a dinner party for my boss and his wife. it's their 25th wedding anniversary and my boss is getting a bonus. I should make some kind of meat dish.
I have to do a special dinner for my boss and his wife who are visiting from out of town. it's their first visit since announcing they're getting married. I should make some kind of
I have to go to my daughter's bachelorette party
I have to make a cake for a friend's birthday
I have to send out a newsletter
I have to fit everything into my schedule
I have to go to the gym again because I'm hopelessly out of shape
I have to get my nails done again because I'm hopelessly out of shape
I have to go to the gym again because my daughter is getting married in 10 days and I've got to look my best
I have to go to the gym again because my daughter is getting married and I'm supposed to look my best
I have to get my nails done again
I have to make a reservation for a chef's dinner that I'm hosting for my husband
I have to make a reservation for a dinner party that I'm hosting for my husband
I have to see about an insurance policy for the house
I have to see about a policy on the car
I have to go to the bank and deposit some checks
I have to take care of some business that has to do with my husband's company and it's not due to be finalized until thursday
I have to see about a car insurance policy that we just bought. it's supposed to be here next week, but it's not here yet.
I have to see about a policy on a painting we bought for our living room. we're going to have it hung next week
I have to make a reservation for
I have to prepare a dinner for my friend paul and I'm supposed to clean the kitchen afterwards
I have to clean the kitchen and the house afterwards
I have to clean the house and kitchen afterwards
I have to meet and greet my new clients
I have to do some editing for my client
I have to go to the bank
I have to answer this email from the client that says "we need you to send us an e-mail proof of your logo"
I have to do this thing that I have to do
I have to take a shower
I have to make a presentation for my boss
I have to buy a new bra
I have to make an appointment with my therapist
I have to make an appointment with my doctor
I have to make an appointment with my acupuncturist
I have to go shopping
I have to get my hair done for my wedding
I have to go to the hair salon for my daughter who is getting highlights
I am trying to get the shower party ready
I have to go to work
I have to go grocery shopping
I have to get my friend rolanda's wedding dress back from the cleaners
I have to go to the gym to workout
I have a meeting this afternoon
I have to get my ass to a party
I have a dinner party to attend
I have to make an appearance at a friend's wedding
I have to help out at a family event
I have a date with my boyfriend next week
I have a date with my husband next week
I have a date with my husband on friday night
I have to go to a work party for my co-worker, ben
I have to make my dinner for family members
I have to start a new project for my job
I have to organize my home and clean my house
I have to do laundry
I have to do my taxes
I have to make a new year's resolution
I have to call the doctor to remind him about my appointment
I have to work on a project for my boss at work that has been put on hold because of a holiday
I have to go to the gym after work because I'm out of shape
we are supposed to go on a saturday night and we keep scheduling conflicts so I have to cancel the plans with my friends and arrange a new date
we are supposed to go out with friends but we keep canceling because we keep scheduling conflicts
I have to work on a project for work that we've been working on for three months and I'm just now getting to the point where I can finally start working on it
I have to work on a project for work that I've been working on for three months and I'm just now getting to the point where I can start working on it
I have to start writing a book that I've been wanting to write for the past five years
I have to write a book that I've been wanting to write for the past five years
I have to clean out my office
I have to keep up with all of the emails that are going back and forth between my co-workers and me because we're all really busy
I have to keep up with all of the emails that are going back and forth between
I have to sack out at the beach for a few hours and drink a few beers
I have to go grocery shopping with my sister and her children
I have to go to the gym and lift weights for an hour
I have to take my baby to his first ballet recital
I have to go to the drug store and get some more prescriptions filled
I have to go to the bank and talk to the teller about my account
I have to go to the gym and I'm supposed to do my sit-ups and pull-ups
I have to go to a friend's house and I'm supposed to cook a casserole
I have to go to the zoo and I'm supposed to feed the bears
my friend garret is getting married and I have to give toast
my friend garret is getting married and I have to give a speech
I have to work on my resume
I have to convince my boss that I can do a job
I have to go meet a friend of mine who has been living in new zealand for the last 2 years
I have to go meet a friend of mine, who has been living in new zealand for the last 2 years
I have to go meet my friend garret, who has been living in new zealand for the last 2 years
I have to have a meeting with my boss to discuss the business
I have to have a meeting with my boss to discuss the sales of the business
I have to go skiing with my boss
I have to sell a house I'm renting
I have to go to the grocery store and get more wine for my dinner party
I have to buy the new lulu lemonade
I have to go to the gym and do weights, cardio and zumba
I have to take my dog for a walk and I'm supposed to be in a meeting now
I have to start writing this blog post
I have to go on a date with my husband
I have to read a book.
I have to go on a diet.
I have to go to work.
I'm supposed to go to the gym, but I'm so busy that I couldn't find the time
I'm supposed to meet a friend of mine for coffee in a few minutes but I have an important call
I have to meet my boss at the office for lunch
I have to run an errand for my friend
I have to meet my friend at the airport on her way home from vacation.
I'm supposed to meet my sister for coffee but she just had a baby, it's around dinner time.
I have an important meeting with my boss and I told him that we should meet at noon for lunch. he messaged me last night that he
I have to make a construction estimate for a new house that I'm building
I have to go to the office, I have to go 
I have to go to the airport, I have to go
I have to work late with my boss and I don't want to get into the office and make her angry
I have to choose between having dinner with my friend alva and my friend fabrizio, and they both want to have dinner with me at the same time.
I have to attend a meeting with my boss.
I'm supposed to attend a meeting at work.
I have to go to the dentist.
I have to go to lunch with my friend alva.
I have to go to the gym.
I have to go to the mall.
I have to go to costco.
I have to go to the beach.
I have to go to the library.
I have to go do a face-lift.
I have to go do a root canal.
I have to go do a leg lift.
I have to go do a shoulder lift.
I have to write this article for the local paper
and there are many others that come to mind
I'm trying to wrap up a project and I have to make a presentation to my boss
I have to go to a family meeting at work. this family meeting is important because my supervisor is leaving the company and I have to find out his replacement.
I have to go to a meeting at the church and I was told that I have to attend.
I have to go to the grocery store and get coffee for my husband who is studying for an exam
I have to decide whether or not we should host a dinner party for some of my family members at the end of this month.
I'm planning a dinner party for myself and I'm also supposed to make dessert, but it's been so long since I've worked in the kitchen that I'm having trouble deciding what we should make
I have to mow the lawn and pitch a screenplay at the same time
I have to attend my sons little league game
I have to attend my sons little league game and pitch a screenplay
I have to attend my sons little league game and mow the lawn
I have to mow the lawn and pitch a screenplay at the same time.
I have to take my friend to the hospital because he's not feeling well
I have to take the dog for walk, make sure he's not in heat
I have to work on the script and get it ready to pitch
I have to go to the grocery store
I have to make a toast at a wedding
I have to get coffee with my friend and I am supposed to be on the phone
I have to get groceries
I have to schedule some appointments
I have to help my friend with his taxes
I have a date that evening
I have to attend my sons little league game
I have to attend my sons little league game and pitch a screenplay
I have to attend my sons little league game and mow the lawn
I have to mow the lawn and pitch a screenplay at the same time.
I have to take my friend to the hospital because he's not feeling well
I have to take the dog for walk, make sure he's not in heat
I have to work on the script and get it ready to pitch
I have to go to the grocery store
I have to make a toast at a wedding
I have to get coffee with my friend and I am supposed to be on the phone
I have to get groceries
I have to schedule some appointments
I have to help my friend with his taxes
I have a date that evening
I have a meeting with my boss
I have to go home after my meeting at work to rest up for my week of vacation
I have to get my cat to the vet
I have to go to bed
I have to sign off a zoom call with the customer
I have to get on another zoom call
I have a zoom call to attend
I have to take care of a customer with a problem with his account
I have to take care of another customer with an account problem
I have to take care of a zoom call that just started
I have to get on yet another zoom call
I have to take care of a customer with a security issue
I have to take care of yet another customer with a security issue
I have to take care of yet another zoom call.
I have to get on yet another excruciatingly long all hands zoom call
I have go to an online happy hour with my co-workers
I have to get the covid-19 vaccine
I have to do an online presentation for my local chamber of commerce
I have to do an online presentation for the state legislature
I have to do an online presentation for my local school board
I have to do a live presentation for my local school board
I have to do a live presentation for my local town council.
I have to do a live presentation for my town council.
I have to do a live presentation for my state legislature.
I have to do a live presentation for my state legislature and the governor. 
I have to do a live presentation for my state legislature and the governor.
I have to do a live presentation as part of my state legislature's budget vote.
I have to schedule that client call
I have to find that invoice
I have to figure out how to get my work done in the next 2 hours while also taking on other tasks
I have to figure out how to pay bills, pay the electric bill, and get gas for the car all at the same time
I have to figure out how to pick up my kids from school
I have to figure out what to do with the extra money that I am getting from my employer (taxes, 401, etc)
I have to figure out what to do with all of this extra time that I have now that I don't need to work anymore.
I have to figure out what to do with the extra money that I am getting now that I don't need to work anymore.
I have to figure out what the heck happened and how to
I have to send an email to my colleagues
I have to work on a project that is due tomorrow
I have to get home early to help my wife with her weekly baking project.
on monday I have to get the covid-19 vaccine
I have to get my teeth cleaned
I have to get my teeth cleaned again
I have to draft a few more tickets for customer support
I have to go to
I have to pick up my oldest son from daycare
I have to take an emergency call from my mother
I have to take an emergency call from my wife
I have to take an emergency call from my girlfriend
I have to take an emergency call from my wife's mother
I have to take an emergency call from my girlfriend's mother
I have to take an emergency call from my therapist
I have to take an emergency call from my son's teacher
I have to pick up my grandmother at the airport
I have to pick up my grandmother's friend at the airport
I have to take an emergency call from my father-in-law
I have to take an emergency call
I have to go to lunch with my co-workers 
I have to have a 1:1 with a client
I have to have a 1:1 with my supervisor
I have to have a 1:1 with my boss
I have to do a check-in call
I have to do a lead follow-up call
I have to go to a new client meeting
I have to do an evening one-on-one with the client
I have to do another early morning meeting
I have to do a quarterly performance review
I have to write an annual performance review
I have to go to a business lunch with my boss
I have to go to a saturday morning team meeting
I have to walk
I have to go to a gis meeting
I have to go to a gis meeting on a tuesday
I have to take my boss out for a coffee and we have to talk about how we are going to make this new division work
I have to get my car washed
I have to get my car painted
I have to get my car serviced
I have to get my car tuned
I have to get new tires
I have to get my car fixed
I have to get a new ignition lock for my car
I have to get my car inspected
I have to get my car inspected again
I have to get my car serviced again
I have to get my car serviced again...
I have to get my car serviced again..
I have to do a "survey" with my co-workers
I need to figure out how to do an online happy hour with my co-workers
I need to do a "survey" with my co-workers
I have to do an online happy hour with my co-workers
I need to get the covid-19 vaccine
I have to get
I have to get the flu shot
I have to make a trip to the dmv
I have to take my kid to the ymca
I have to go to my second job
I have to go get a pizza
I have to get the flu shot again
I am going to be invited to something
I have to go teach a class on friday morning
I have to go on a road trip
I have to go to another meeting since I'm on vacation this week
I have a pick up game of softball this morning and I can't miss it
I have to go pick up a prescription for my mother, she is sick
I have to go pick up my kid from school and then take him for a doctor's appointment
I have to rework my schedule so I can attend an upcoming meeting in the morning
I have to go to work on a vehicle
I have to run to the store for a can of anti-freeze
I have to drive to work
I have to get ready for work
I have to go to work
I have to do paperwork
I have to go to the bathroom
I have to wash my hair
I have to get out of bed
I have to stretch
I have to do my leg stretches
I have to do my calf stretches
I have to do my quad stretches
I have to do my hamstring stretches
I have to do my back stretches
I have to do my side stretches
I have to do my neck stretches
I have to check my email
I have to do something else and not these
I have to go to a lecture that I'm not interested in
I have to go to the store for a birthday present
I have to go home and watch this show that I don't care about
I have to go to the gym
I have to go to the dmv for yet another stupid registration renewal
I have to get a new prescription for my medication
I have to go to the doctor's office
I have to go to my son's baseball game
I have to go to my daughter's soccer game
I have to go to my daughter's lacrosse game
I have to get a flu shot 
I have to get an allergy shot 
I have to go to the grocery store for my son's birthday
I have an interview for an open position
I have to go to an eyecare appointment
I have to prepare a lesson for my students. 
I have to go speak to the principal about my students' grades. 
I have to go to the school board. 
I have to get a new computer ordered for school. 
I have to write a request for a new computer. 
I have to talk to the tech guy about my computer. 
I have to make a presentation for the district
I have to talk to the principal about my presentation. 
I have to make a formal presentation for the board. 
I have to make another presentation for the district. 
I have to make another presentation for the board. 
I have to meet my step-daughter for a play date
I have to pick up my husband from the hospital
I have to pick up the dry cleaning
I have to stop by the bank
I have to go grocery shopping
I need to pick up my son from school
I have to make a stop at the library
my son has a play date coming up
my daughter has a swim meet coming up
my daughter has to get her hair cut
I have to get my son's homework done
I have to get my daughter's homework done
I have to get my husband's homework done
I have to pick up my step-daughter from the play-date
I have to get my husband from the
I have to get my mom to an appointment and I am also late for my own appointment
I have to get my dog groomed
I have to get my nails done
I have to get groceries
I have an ulcer
I have to walk a patient to the bedside of another patient
I have to return a call with a patient's mom
I have to go to a meeting to discuss the patient's care
I have to purchase a new set of tires
I have to get on the all hands zoom call
I have to buy a new car
I need to go to an online happy hour with my co-workers
I have to pick up my car from the body shop
I have to go to an online happy hour with my co-workers.
I need to go to an online happy hour with my co-workers.
I have to pick up my car from the body
I have to get a prescription filled for my sick cat
I have to get a prescription refilled for my sick cat
I have to go to the pharmacy on the way home from work for my sick cat
I have to go to the vet early, just in case the vet makes me wait anyways
I have to go to the vet and wait for like 4 hours
I have to get a prescription for my sick cat
I have to pick up a prescription for my sick cat
I have to go to the vet, and wait for like 4 hours
I have to get my license renewed
I have to take my wife to the doctor
I have to get my work boots repaired.
I have to finish my side project, the stock market simulation game
I have to see the client and get them a quote for this year's advertising budget 
I have to be in the center of the office for a half an hour to get our main it guy's attention so he can help me connect my modem to the new router we bought 
I have to see the customer about some landscaping issues (they are a little weird)
I have to make a video for the website on how to use our new pos system
I have to change my date on the invoices someone else decided they needed
I have to train some new vendors to use the software we bought
I have to prepare my proposal for next year's entertainment budget
I have to make sure my boss and my new boss are both going to be there for my presentation this afternoon
I have to teach
I have to relax and watch tv for the first time all week
I have to get on yet another excruciatingly long all hands zoom call.
I have to book the catering for my nephew's birthday party
I need to figure out where I can get my hair cut and mani/pedI done at the same time
I have to look for a new job
I have a book signing with my publisher
I have to drive back to the apartment I am renting because I can't find my keys
I have to get an oil change for my car
I have to take my car in for a state inspection
I have to get gas for my car
I have to pick up my son from school
I have to take my son to his first day of preschool
I have to get lunch for the team meeting after work today
I have to pick up my son from preschool
I have to make sure the team meeting goes smoothly today
I have to make sure my son's school
I have to organize the team's travel for our next project
I have to finish reading the damn book
I have to make a decision on how we're going to structure the uat project.
I have to get on a conference call with our overseas team and discuss our next project
I have to edit this damn powerpoint presentation again
I have to go to the office for yet more team reviews
my co-workers are all going to a fancy party today and we have nothing to wear
my wife has a brain surgery scheduled for today and I have to take the kids to the doctor
I have to go to another "lunch & learn" training class with my boss
I have to drive my boss to the airport
I have to go home and write a report for my boss
I have to go home and do shit work for my boss
I have to pay the rent
I have go to an in-person meeting
I have to put together a proposal for the boss
I have to put together a proposal for sales
I have go to a presentation for the boss
I have to put together a presentation for sales
I have to go to a presentation for sales
I have to do a weekly test with a client
I have to complete a paper
I have to update our website
I have to update our it policy
I have to fix a problem with our infrastructure
I have to make sure the computers are running properly
I have to make sure the servers are running properly
I have to finish my presentation
I have to prepare our monthly report
I have to prepare our annual report
I have to complete the quarterly financial report
I have to complete the annual financial report
I have to update the "trouble shooting" manual
I have to update the it handbook
I have to check the log for errors
I have to get my children ready for school
I have to get my kids
I have to give yet another presentation
I have to go to yet another conference.
I have to take a shower.
I have to get ready for yet another meeting
I have to go to yet another meeting.
I have to go to another meeting to talk about yet another new csc policy
I have a meeting with my boss
I have to go home after my meeting at work to rest up for my week of vacation`.split("\n");

export default excuses;
